const dive = (currentKey, into, target) => {
    for (const i in into) {
        if (Object.prototype.hasOwnProperty.call(into, i)) {
            let newKey = i;
            const newVal = into[i];
            if (currentKey.length > 0) {
                newKey = currentKey + "." + i;
            }
            if (typeof newVal === "object") {
                dive(newKey, newVal, target);
            }
            else {
                target[newKey] = newVal;
            }
        }
    }
};
/**
 * Flattens an object.
 *
 * @param {Obj} obj The object to flatten.
 * @returns {Obj} The flattened object.
 */
export const flatten = (obj) => {
    const newObj = {};
    dive("", obj, newObj);
    return newObj;
};
